import { ChangeDetectionStrategy, Component, Input, Output, HostListener, EventEmitter} from '@angular/core';
import { CalendarEventHolder  } from '../Models/Holders/calendareventholder.model';
import { NgClass } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@Component({
    selector: 'justification-modal',
    templateUrl: 'justificationmodal.component.html',
    imports: [NgClass, ReactiveFormsModule, FormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class JustificationModalComponent {

	@Input() currentEvent: CalendarEventHolder = new CalendarEventHolder();
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('title') modalTitle: string;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('open') justificationModalOpened: boolean;

  // Output event
  @Output() openChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	@Output() closeModal: EventEmitter<any> = new EventEmitter();

	@HostListener('keydown.esc', ['$event'])
	close(resultToSend: Event | string) {
		this.justificationModalOpened = false;
    this.openChange.emit(this.justificationModalOpened);
		this.closeModal.next(resultToSend);
	}

}
